module.exports = __webpack_public_path__ + "img/5.37852e71.png";